import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import { generateVariantColumns } from "../../helper";
import DataTableComponent from "../../../../components/common/DataTable/DataTable";

function VariantTable({ variants, productDetails }) {
  const tableData = variants.reduce(
    (acc, variant) => {
      if (variant.variantName === "size") {
        acc.sizes = variant.variantValue; // Collect all sizes
      } else if (variant.variantName === "color") {
        acc.colors = variant.variantValue; // Collect all colors
      }
      return acc;
    },
    { sizes: [], colors: [] } // Initialize sizes and colors arrays
  );

  // Generate combinations of sizes and colors
  const combinedTableData = tableData?.sizes?.flatMap((size) => {
    return tableData?.colors?.map((color) => ({
      id: `size-${size}-color-${color}`,
      customsize: size,
      customcolor: color,
      price: productDetails.productPrice || "",
      stock: productDetails.productStock || "",
      weight: productDetails.productWeight || "",
      dimensions: `${productDetails.productDimentionL}x${productDetails.productDimentionW}x${productDetails.productDimentionH}`,
    }));
  });

  const tableData2 = variants.flatMap((variant) => {
    if (variant.variantName === "size" || variant.variantName === "color") {
      return variant.variantValue.map((value) => ({
        id: `${variant.variantName}-${value}`,
        customsize: variant.variantName === "size" ? value : "",
        customcolor: variant.variantName === "color" ? value : "",
        price: productDetails?.productPrice || "",
        stock: productDetails?.productStock || "",
        weight: productDetails?.productWeight || "",
        dimensions: `${productDetails?.productDimentionL}x${productDetails?.productDimentionW}x${productDetails?.productDimentionH}`,
      }));
    }
    return [];
  });

  console.log(tableData2);

  const variantColumns = generateVariantColumns();

  return (
    <Box mt={2}>
      <Typography
        sx={{
          fontSize: "20px",
          fontWeight: 600,
          color: "background: rgba(28, 38, 48, 1)",
        }}
      >
        Variant Table
      </Typography>
      {combinedTableData.length > 0 ? (
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Paper
            sx={{
              width: "100%",
              borderRadius: "4px",
              border: "1px solid #E5E5E8",
            }}
          >
            <DataTableComponent
              data={combinedTableData}
              columns={variantColumns}
              customStyles={{
                table: {
                  style: {
                    borderCollapse: "collapse",
                  },
                },
                headCells: {
                  style: {
                    borderRight: "1px solid rgba(229, 229, 232, 1)",
                  },
                },
                cells: {
                  style: {
                    borderRight: "1px solid rgba(229, 229, 232, 1)",
                  },
                },
              }}
            />
          </Paper>
        </Box>
      ) : tableData2?.length > 0 ? (
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Paper
            sx={{
              width: "100%",
              border: "1px solid #E5E5E8",
              borderRadius: "4px",
            }}
          >
            <DataTableComponent
              data={tableData2}
              columns={variantColumns}
              customStyles={{
                table: {
                  style: {
                    borderCollapse: "collapse",
                  },
                },
                headCells: {
                  style: {
                    borderRight: "1px solid rgba(229, 229, 232, 1)",
                  },
                },
                cells: {
                  style: {
                    borderRight: "1px solid rgba(229, 229, 232, 1)",
                  },
                },
              }}
            />
          </Paper>
        </Box>
      ) : (
        <></>
      )}
    </Box>
  );
}

export default VariantTable;
